/* eslint-disable no-template-curly-in-string */
import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Icon, Button, CountdownButton, Drawer } from '@adc/ui-core'
import classnames from 'classnames/bind'
import ProgressBar from '../../progressBar'
import createBulkMessage from '../createBulkMessage'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const BulkUpdateDrawer = ({
  records,
  submitBulkUpdate,
  pristine,
  submitting,
  invalid,
  open,
  onClose,
  entityName,
  drawerTitle = 'Bulk Update ${count} ${entityName}',
  actionButtonText = 'Bulk Update ${count} ${entityName}',
  drawerRef = _.noop,
  children,
  itemsUpdated,
  itemCount,
  useCountdownButton,
}) => {
  const renderTitle = () => {
    const numberOfRecords = _.size(records)
    const text = createBulkMessage(drawerTitle, numberOfRecords, entityName)

    return (
      <span>
        <Icon name='write square' color='info' />
        <span className={cx('title')}>{text}</span>
      </span>
    )
  }

  const numberOfRecords = _.size(records)
  const buttonText = createBulkMessage(
    actionButtonText,
    numberOfRecords,
    entityName
  )
  const percent = (itemsUpdated / itemCount) * 100
  const isDisabled = pristine || submitting || invalid
  const isLoading = submitting || percent > 0
  const updateButton = useCountdownButton ? (
    <CountdownButton
      disabled={isDisabled}
      loading={isLoading}
      size='small'
      elmId='bulk_update'
      role='primary'
      onClick={() => submitBulkUpdate(records, onClose)}
    >
      {buttonText}
    </CountdownButton>
  ) : (
    <Button
      disabled={isDisabled}
      loading={isLoading}
      size='small'
      elmId='bulk_update'
      role='primary'
      onClick={() => submitBulkUpdate(records, onClose)}
    >
      {buttonText}
    </Button>
  )

  let bulkUpdateStatus
  if (percent < 100) {
    bulkUpdateStatus = 'Processing...'
  } else if (percent === 100) {
    bulkUpdateStatus = 'Complete! (Refreshing grid...)'
  } else {
    bulkUpdateStatus = ''
  }

  const closeButton = (
    <Button
      size='small'
      disabled={percent > 0}
      onClick={onClose}
      elmId='bulk_cancel'
    >
      Cancel
    </Button>
  )

  const progressBar = (
    <ProgressBar percent={percent} label={bulkUpdateStatus} indicating />
  )

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={renderTitle()}
      drawerRef={drawerRef}
      footerLeftButton={updateButton}
      footerRightButton={closeButton}
      progressBar={progressBar}
    >
      <div className={cx('content')}>{children}</div>
    </Drawer>
  )
}

BulkUpdateDrawer.propTypes = {
  records: PropTypes.array.isRequired,
  submitBulkUpdate: PropTypes.func.isRequired,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  invalid: PropTypes.bool,
  entityName: PropTypes.string.isRequired,
  drawerTitle: PropTypes.string,
  actionButtonText: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  drawerRef: PropTypes.func,
  itemsUpdated: PropTypes.number,
  itemCount: PropTypes.number,
  useCountdownButton: PropTypes.bool,
}

export default BulkUpdateDrawer
